export class NavigationTab {
    name: string;
    path: string;
    default = false;
    hasPermission = true;

    constructor(value?: Partial<NavigationTab>) {
        if (value) {
            Object.assign(this, value);
        }
    }
}

export class NavigationInfo {
    tabs: Array<NavigationTab> = [];
    selectedTab: NavigationTab;

    constructor(...items: Partial<NavigationTab>[]) {
        if (items && items.length > 0) {
            items.forEach(tab => {
                this.tabs.push(new NavigationTab(tab));
            });
            if (this.tabs.filter(t => t.default).length === 0) {
                this.tabs[0].default = true;
            }
        }
    }
}
